export const App_Url_New = {
  ApiEndPoint: {
    AddOnsApiMasterTravel: "/master/coverage-master/1",
    NewQuoteEmailSend: "/users/get-quote-email",
    UpdateSession: "/users/update-session",
    commissionLedgerList: "/auth/commissions/ledger",
    commissionsListing: "/auth/commissions",
    commissionInsurer: "/auth/commissions/filters/insurers",
    commissionCountry: "/auth/commissions/filters/countries",
    commissionStatus: "/auth/commissions/filters/statuses",
    commissionLedgerDateRange: "/auth/commissions/ledger/filters/date-ranges",
  },
  ApiOcrEndPoint: {
    ExtractDocument: "/users/extract-pdf",
  },
  defaultAccept: ".pdf,.jpg,.jpeg,.png",
  frontLinks: {
    insurance: {
      carGetQuote: "/car-get-quote",
      carPolicyResult: "/car-get-quote/policy",
      travelGetQuote: "/travel-get-quote",
      travelPolicyResult: "/travel-get-quote/policy",
    },
    actions: {
      uploadDocuments: "/travel-get-quote?step=4",
    },

    services: {
      claims: "/claims",
      roadsideAssistance: "/roadside-assistance",
      complaints: "/complaints",
    },
    aboutUs: "/about-us",
  },

  backLinks: {
    bindquote: "/travel/bind-quotes",
    update_session: "/users/update-session",
    document_upload: "/users/document/upload",
    user_update_session: "users/update-session",
  },
  personaldetails: {
    Personal: "/users/create-session",
    mobile_country_code: "/master/mobile-country-codes",
  },
  secured: {
    frontlinks: {
      login: "/login",
      dashboard: "/dashboard",
      leads: "/leads",
      clients: "/clients",
      quotes: "/quotes",
      addQuotes: "/quotes/add-quotes",
      clientFetchQuote: "/clients/quotes",
      pipeline: "/pipeline",
      pipelineAnalytics: "/pipeline-analytics",
      opportunities: "/opportunities",
      opportunitiesAdd: "/opportunities/add",
      rfq: "/rfqs",
      policies: "/policies",
      team_members: "clients/team-members",
      EDIT_QUOTE_URL: "/opportunities/edit",
      formConfig: "/form-config",
      commissions: "/commissions",
      commissionsLedger: "/commissions-ledger",
    },
    backlinks: {
      create_lead: "/auth/client/create",
      CREATE_QUOTE: "/auth/opportunities/create-quote/",
      CREATE_RFQ_DOC: "/auth/opportunities/create-rfq-doc",
      delete_leads: "/auth/client/delete",
      user_login: "/users/login",
      send_otp: "/users/send-otp",
      verify_otp: "/users/validate-otp",
      get_session: "/users/get-session/",
      GET_LIST_LOB: "/auth/master/list-lob",
      GET_FORM_CONFIG_LOB_LIST: "/submission/lobs",
      // Shared prefix the remote Form Config screens prepend to every form-config path.
      FORM_CONFIG_API_PREFIX: "/auth/form-config",
      GET_LIST_INSURER: "/auth/insurer-master/list-insurer",
      GET_LIST_QUOTE: "/auth/opportunities",
      GET_OPPORTUNITIES_LIST: "/auth/opportunities/list",
      GET_RFQ_LIST: "/auth/rfq/list",
      GET_RFQ_NEGOTIATION_LIST: "/auth/rfq/negotiation-list",
      PIPELINE_LIST: "/auth/pipeline/list",
      policy_status_list: "/master/policy-status-list",
      pipeline_data: "/pipeline_data",
      quote_allocation: "/auth/quote/quote-allocation",
      QUOTE_BULK_UPSERT: "/auth/opportunities/bulk-upsert",
      quote_list: "/auth/quote/quotes",
      RFQ_LIST: "/auth/rfq/rfq-list",
      SEND_RFQ: "/auth/rfq/send-rfq",
      UPDATE_RFQ_ROUND: "/auth/opportunities/update-rfq-round",
      update_lead: "/auth/client/update",
      dashboard_count: "/auth/dashboard/dashboard-count",
      filters: "/master/lob-list/",
      policies_by_insurer: "/auth/dashboard/policies-by-insurer-count",
      policy_details: "/policies/policies-detail/",
      list_industries: "/auth/master/list-industries",
      list_leads: "/auth/client/list",
      clients_get_quote_email: "/auth/client/get-quote-email",
      benificiary_dropdown: "/users/get-beneficiary/",
      BASE_URL_B2B: import.meta.env.VITE_APP_ENDPOINT_URL,
      ADD_OFFERED_VALUES: "/auth/rfq/round",
      ACCEPT_OFFERED_VALUES: "/auth/rfq/accept-rfq",
    },
  },
  retail: {
    frontlinks: {
      retail_dashboard: "/retail-dashboard",
    },
  },
  PopUpStatus: {
    SHOW: "show",
    HIDE: "hide",
  },
  PopupKeys: {
    AUTH_RETAIL_LOGIN: "AUTH_RETAIL_LOGIN",
    AUTH_CAR_QUOTE_RESUME: "AUTH_CAR_QUOTE_RESUME",
    AUTH_TRAVEL_QUOTE_RESUME: "AUTH_TRAVEL_QUOTE_RESUME",
    LOGOUT_CONFIRM: "LOGOUT_CONFIRM",
    COMPARE_QUOTES: "COMPARE_QUOTES",
    QUOTE_DETAILS: "QUOTE_DETAILS",
    TRAVEL_QUOTE_DETAIL: "TRAVEL_QUOTE_DETAIL",
    CAR_QUOTE_DETAIL: "CAR_QUOTE_DETAIL",
  },
};
